import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";

import {
  getSideBarfilesActions,
  SetTheBlacklistActions,
  setTheoptions,
  setThecountBasedRenders,
  ////--filters
  setRegionActions,
  setZoneActions,
  setGeoLoactionStateAction,
  setTheEmployee_Block_RequestState,
  setTheEmployee_Block_RequestRegion,
  setTheEmployee_Block_RequestZone,
  setheEmployee_Block_RequestdesignationStatus,
  setTheEmployee_Block_RequestStateStatus,
  setTheEmployee_Block_RequestRange1,
  setTheEmployee_Block_RequestRange2,
  setTablePositionPersist
} from "../../../Redux/Slice";
import Select from "react-select";
import ReactTable from "../../AppComponent/Table";
import BlacklistApprove from "./BlacklistApprove";
import _, { values } from "lodash";

import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";

import BlackListCeatePoup from "./BlackListCreatePop";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";

import { differenceInDays } from "date-fns";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useDebouncedEffect from 'use-debounced-effect';


const BlackList = () => {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
    const TablePositionPersist = useSelector(
    (state) => state.PreviousPagePosition.TablePositionPersist
  );
  const UserObjectData = useSelector((state) => state.users.UserData);

 const [dtpageindex, setdtPageindex] = useState(
    TablePositionPersist?.BlocklistRequestedPagelist?.page == undefined
      ? 1
      : TablePositionPersist.BlocklistRequestedPagelist.page
  ); 
  const [dtpagesize, setdtPagesize] = useState(20);
  const [pageSize, setPageSize] = useState(20);
  const [newpages, setNewpage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
const [search, setsearch] = useState(
    TablePositionPersist?.BlocklistRequestedPagelist?.search == undefined ||
    TablePositionPersist?.BlocklistRequestedPagelist?.search ==""
      ? ""
      : TablePositionPersist.BlocklistRequestedPagelist.search
  );  
  const state = useSelector((state) => state);
  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);
  const [EmployeePop, setEmployeePopblack] = useState(false);
  const [EmployeeIDsblacklist, setEmployeeIDsblack] = useState();
  const [createblack, setcreatepoupblack] = useState(false);
  const [sno, setsno] = useState(0);

  ///---filter for white collar--------
  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "",
      label: "ALL",
    },
    {
      value: "1",
      label: "UDS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);
  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(
    state.StateManagementOverallCall.Employee_Block_RequestRange1
  );
  var gt = convert(
    state.StateManagementOverallCall.Employee_Block_RequestRange2
  );
  const [range, setrange] = useState(
    state.StateManagementOverallCall.Employee_Block_RequestRange1 == ""
      ? // [it, gt]
        []
      : [it, gt]
  );

  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      dispatch(setTheEmployee_Block_RequestRange1(range[0]));
      dispatch(setTheEmployee_Block_RequestRange2(range[1]));
    }
  }, [range]);

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  //----Handle----Date=-----Changes---
  const handlechangedate = (value) => {
    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };

  const [filterForWhite, setFilters] = useState({
    white_collar:
      state.StateManagementOverallCall.Employee_Block_Requestdesignation
        ?.value == ""
        ? ""
        : state.StateManagementOverallCall.Employee_Block_Requestdesignation
            ?.value == 1
        ? true
        : false,
  });
  const HandleEMprole = (e) => {
    setdtPageindex(1);

    if (e != null) {
      dispatch(setheEmployee_Block_RequestdesignationStatus(e));
      if (e.value == 1) {
        setFilters({
          ...filterForWhite,
          white_collar: true,
        });
      } else if (e.value == 2) {
        setFilters({
          ...filterForWhite,
          white_collar: false,
        });
      } else if (e.value == "") {
        setFilters({
          ...filterForWhite,
          white_collar: "",
        });
        dispatch(
          setheEmployee_Block_RequestdesignationStatus({
            value: "",
            label: "ALL",
          })
        );
      }
    }
  };

  ///----------

  const FileterState = {
    status:
      state.StateManagementOverallCall.Employee_Block_RequestStatusState?.value,
  };
  const [selectDisplay, setDisplay] = useState([]);
  const [selectVal, SetSelectval] = useState(FileterState);
  const [FState, SetStates] = useState(false);
  ////--_FIlter--------------------------
  const [Filter, SetFilter] = useState(true);
  /// console.log(state.NumberCounts, "fsdf");
  const options = [
    { value: "", label: "All" },
    { value: "pending", label: "Pending" },
    { value: "decline", label: "Decline" },
    { value: "approved", label: "Approved" },
  ];

  const [place, SetPlace] = useState("");
  const [sel, setSelected] = useState();
  ///--filter----------------
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState(
    state.StateManagementOverallCall.Employee_Block_RequestRegion
  );
  const [multiselect3, setMuliselect3] = useState(
    state.StateManagementOverallCall.Employee_Block_RequestZone
  );
  const [nameList4, setOptions4] = useState([]);
  const [Zone, setZone] = useState([]);
  const [data, setData] = useState({
    zone: state.StateManagementOverallCall.Employee_Block_RequestZone?.value,
    state: state.StateManagementOverallCall.Employee_Block_RequestState?.value,

    region:
      state.StateManagementOverallCall.Employee_Block_RequestRegion?.value,
  });
  const [multiselect, setMuliselect] = useState(
    state.StateManagementOverallCall.Employee_Block_RequestState
  );

  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      const payload = {
        search: search,
        page_size: 20,
        page: dtpageindex,
        selectVal: selectVal,
        data: data,
        white_collar: filterForWhite.white_collar,
        from_date: range[0],

        to_date: range[1],
      };
      dispatch(SetTheBlacklistActions(payload));
              dispatch(
        setTablePositionPersist({
          data: payload,
          pageName: "BlocklistRequestedPagelist",
        })
      );

    }
  }, [selectVal, data, filterForWhite, range, dtpageindex ,search]);


  const handleNext = (next) => {
        setdtPageindex(next + 1); 
  };

   const GotoEnteredPage =(gotopage)=>{
     setdtPageindex(gotopage)
   }

   const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
   
    }
  };
  ///----filter-----
  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
};

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);
  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: currentPage,
      counts: 1,
      region_id: data.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [data.region, SearchedVal.zoneSearch]);
  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: currentPage,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count)
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);
  useEffect(() => {
    const Datas = [];
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.GeoState.State.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.state_name.toUpperCase(),
        });
      });
      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];
    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name.toUpperCase(),
        });
      });
      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setData({
        ...data,
        region: selectedVal.value,
      });

      dispatch(setTheEmployee_Block_RequestRegion(selectedVal));
      dispatch(setTheEmployee_Block_RequestZone({ value: "", label: "ALL" }));
    }
    if (selectedVal == null) {
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

      dispatch(setTheEmployee_Block_RequestRegion({ value: "", label: "ALL" }));
      dispatch(setTheEmployee_Block_RequestZone({ value: "", label: "ALL" }));

      setData({
        ...data,
        region: "",
        zone: "",
      });
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setData({
        ...data,
        zone: selectedVal.value,
      });
      dispatch(setTheEmployee_Block_RequestZone(selectedVal));
    }
    if (selectedVal == null) {
      setData({
        ...data,
        zone: "",
      });
      setMuliselect3({ value: "search", label: "Search" });
      dispatch(setTheEmployee_Block_RequestZone({ value: "", label: "ALL" }));
    }
  };
  const handleSelectChange = (selectedVal) => {
    console.log(selectedVal, "selectedval");
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

      dispatch(setTheEmployee_Block_RequestState(selectedVal));
      dispatch(setTheEmployee_Block_RequestRegion({ value: "", label: "ALL" }));
      dispatch(setTheEmployee_Block_RequestZone({ value: "", label: "ALL" }));

      setData({
        ...data,
        state: selectedVal.value,
        region: "",
        zone: "",
      });
    }
    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

      dispatch(setTheEmployee_Block_RequestState({ value: "", label: "ALL" }));
      dispatch(setTheEmployee_Block_RequestRegion({ value: "", label: "ALL" }));
      dispatch(setTheEmployee_Block_RequestZone({ value: "", label: "ALL" }));

      setData({
        ...data,
        state: "",
        zone: "",
        region: "",
      });
    }
  };
  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];
    setZone(state.ZonePart.Zone);
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.zone_name.toUpperCase(),
        });
      });
      setOptions4(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);
  

   ///-----State----Input Changes
   const handleInputChange = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        stateSearch: Val,

    });

};

///---Region-----------------
const handleInputRegion = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        regionSearch: Val,
    });
};
///----Zone---Name
const handleInputZone = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        zoneSearch: Val,
    });
};

useDebouncedEffect(
  () => {
      if (setSearchDebounance) {
          setSearched({
              ...SearchedVal,
              stateSearch: SearchDebounance.stateSearch,
              regionSearch: SearchDebounance.regionSearch,
              zoneSearch: SearchDebounance.zoneSearch,
          });

      }
  },
  500,
  [SearchDebounance]
);

  const HandleLastPage = () => {
    if (
      currentPage != Math.ceil(state.BlacklistLists.Total_Count / dtpagesize)
    ) {
      const pageEntries = {
        search: search,
        page_size: 20,
        page: Math.ceil(state.BlacklistLists.Total_Count / dtpagesize),
        selectVal: selectVal,
        data: data,
        white_collar: filterForWhite.white_collar,
        // month: Datestate.month,
        // year: Datestate.year,
        // date:Datestate.date ,
        from_date: range[0],

        to_date: range[1],
      };
      dispatch(SetTheBlacklistActions(pageEntries));
      setCurrentPage(Math.ceil(state.BlacklistLists.Total_Count / dtpagesize));
      setNewpage(Math.ceil(state.BlacklistLists.Total_Count / dtpagesize));
    }
  };
  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };


  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);

  }
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    []
  );
  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  const columns = useMemo(
    () => [
      {
        Header: "Tnx Id",
        accessor: "",
        Cell: (row) => {
          if (
            row.row.original.user_id.id != undefined &&
            row.row.original.user_id.id != null
          ) {
            const userId = row.row.original.user_id.id;
            const lastFourDigits = userId.slice(-6);

            return <p>{lastFourDigits}</p>;
          }
        },
      },

      {
        Header: filterForWhite.white_collar ? "User Name" : "Employee Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {row.row.original.user_id.first_name ? (
                <span>{row.row.original.user_id.first_name}</span>
              ) : (
                <span>---</span>
              )}
            </>
          );
        },
      },
      {
        Header: "Created date",
        accessor: "",
        Cell: (row) => {
          const dateString = row.row.original.created_at;
          const dateObject = new Date(dateString);
          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12;

          const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

          const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;
          return (
            <>
              <p
              >
                {`${
                  row.row.original.created_at.slice(0, 10) +
                  "  " +
                  formattedTime
                }`}
              </p>
            </>
          );
        },
      },

      {
        Header: "Reason",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {row.row.original.reason ? (
                <span>{row.row.original.reason}</span>
              ) : (
                <span>---</span>
              )}
            </>
          );
        },
      },

      {
        Header: "Status",
        accessor: "status",
        Cell: (row) => {
          const originalString = row.row.original.status;
          const capitalizedString = capitalizeFirstLetter(originalString);
          return (
            <>
              {row.row.original.status != undefined ? (
                <>
                  {row.row.original.status.toLowerCase() == "pending" ? (
                    <div className="StatusList">
                      <img src={Pendingimg} />
                      <span>{capitalizedString}</span>
                    </div>
                  ) : (
                    <>
                      {row.row.original.status.toLowerCase() == "decline" ? (
                        <div className="StatusList">
                          <div className="DeclineStatus">
                            <span>x</span>
                          </div>
                          <span>{capitalizedString}</span>
                        </div>
                      ) : (
                        <>
                          {row.row.original.status.toLowerCase() ==
                          "approved" ? (
                            <div className="StatusList">
                              <img src={correctIcons} />
                              <span>{capitalizedString}</span>
                            </div>
                          ) : null}
                        </>
                      )}
                    </>
                  )}
                </>
              ) : (
                <span>---</span>
              )}
            </>
          );
        },
      },

      {
        Header: "Action",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <div
                class="actions"
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: "5px",
                }}
              >
                <button
                  className=" btn Status"
                  component="span"
                  onClick={(e) => {
                    setEmployeePopblack(true);
                    setEmployeeIDsblack(row.row.original.id);
                  }}
                >
                  <span className="OuterActionSpan">
                  <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>                 
                     <span className="ActionsList"> Approve </span>
                  </span>
                </button>
              </div>
            </>
          );
        },
      },
    ],
    [sno]
  );

  const ClearState = (Counts) => {
    if (Counts == 2) {
      SetSelectval({
        ...selectVal,

        status: "",
      });
      dispatch(
        setTheEmployee_Block_RequestStateStatus({ value: "", label: "All" })
      );
    }
  };

  //--------_____Filter-----------Based---On----Status--
  const count = (Counts, values, sel, SelectedValues) => {
    setDisplay(SelectedValues);
    setdtPageindex(1);
    setSelected(sel);
    SetStates(true);
    dispatch(setTheEmployee_Block_RequestStateStatus(SelectedValues));

    if (values == "Completed") {
      SetSelectval({
        ///Completed
        ...selectVal,

        status: "completed",
      });
    } else if (values == "Pending") {
      ///Pending
      SetSelectval({
        ...selectVal,

        status: "pending",
      });
    } else if (values == "Decline") {
      //Decline
      SetSelectval({
        ...selectVal,
        is_decline: true,
        is_pending: "",
        approved: "",
        status: "decline",
      });
    } else if (values == "Approved") {
      //Approve
      SetSelectval({
        ...selectVal,

        status: "approved",
      });
    } else if (values == "All") {
      //Approve
      SetSelectval({
        ...selectVal,

        status: "",
      });
    }
  };
  let objectArray = [];
  options.map((item) => {
    if (item.value == 1 && state.NumberCounts.namerednder == "") {
      objectArray.push({ value: item.value, label: item.label });
    } else if (
      item.value == 1 &&
      state.NumberCounts.namerednder == "completed"
    ) {
      objectArray.push({ value: item.value, label: item.label });
    } else if (item.value == 1 && state.NumberCounts.namerednder == "Decline") {
      objectArray.push({ value: item.value, label: item.label });
    }
  });

  const cleaningrange = () => {
    //setrange([gt,it]);
  };

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
  ];

  const openMe = ()=>{
    const rsAnimFade = document.querySelector('.rs-anim-fade');
    if (rsAnimFade) {
      rsAnimFade.style.setProperty('left', '1083.344px', 'important');
      rsAnimFade.style.setProperty('top', '184.109px', 'important');   
    }
   }
  
   const CloseDateRange = ()=>{
    const rsAnimFade = document.querySelector('.rs-anim-fade');
    if (rsAnimFade) {
      rsAnimFade.style.setProperty('display', 'none', 'important');
      // rsAnimFade.style.setProperty('top', '184.109px', 'important');   
    }
   }

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Employee Block Request</h3>

          </div>

       
        </div>

        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "90",
               
            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div className="col-3">
            <label for="validationCustom01" class="form-label">
              State 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                setdtPageindex(1);
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect(e);
              }}
              labelledBy="Select"
              placeholder={"Search"}
              value={multiselect}
            />
          </div>

          <div className="col-3">
            <label for="validationCustom01" class="form-label">
              Region 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                setdtPageindex(1);

                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={true}
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}
            />
          </div>
          <div className="col-3">
            <label for="validationCustom01" class="form-label">
              Zone 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                setdtPageindex(1);

                handleZone(e);
              }}
              options={nameList4}
              isClearable={true}
              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              value={multiselect3}
              labelledBy="Select"
              onInputChange={handleInputZone}

            />
          </div>

          <div className="col-3">
            <label
              for="validationCustom01"
              class="form-label"
              style={{ marginBottom: "11px" }}
            >
              {/* State Name */}
              Select Date
              <span style={{ color: "red" }}>*</span>
            </label>

            <div className="datepicker_dash" style={{ marginTop: "-5px" }}>
              <DateRangePicker
                defaultValue={
                  state.StateManagementOverallCall
                    .Employee_Block_RequestRange1 == ""
                    ? []
                    : [
                        new Date(
                          state.StateManagementOverallCall.Employee_Block_RequestRange1
                        ),
                        new Date(
                          state.StateManagementOverallCall.Employee_Block_RequestRange2
                        ),
                      ]
                }
                onOpen={() => {
                  openMe()
                }}
  onClose={() => {
    CloseDateRange()
  }}

                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                appearance="default"
                placement="bottomEnd"
                size="lg"
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                // style={{ width: 270, padding: 10 }}
                onClean={(e) => cleaningrange(e)}
                onChange={(e) => {
                  if (e != null && e.length === 2) {
                    const [startDate, endDate] = e;
                    const diffDays = differenceInDays(endDate, startDate);
                    setrange([]);
                    e.forEach((newValue) => {
                      const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                      const localISOTime = new Date(newValue - tzoffset)
                        .toISOString()
                        .slice(0, -1);
                      handlechangedate(localISOTime);
                    });
                    
                  }
                }}
              />
            </div>
          </div>
        </div>

        <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
          <ReactTable
            data={state.BlacklistLists.BlackListdataList}
            columns={columns}
            totalItems={state.BlacklistLists.Total_Count}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}

            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            datacount={state.BlacklistLists.Total_Count}
            values={
              state.StateManagementOverallCall.Employee_Block_RequestStatusState
            }
            ApproveRequestFilter={true}

            options={options}
            Filter={Filter}
            count={count}
            ClearState={ClearState}
            placeHold={place}
            ///--- emoloyee role based filters -
            EmployeeRoleTrue={true}
            EmployeeRoleOption={EmpRoles}
            EMpROleSelected={
              state.StateManagementOverallCall.Employee_Block_Requestdesignation
            }
            HandleEMprole={HandleEMprole}
            setsno={setsno}
            sno={sno}
            id={"spe"}
                                     searchVal={TablePositionPersist?.BlocklistRequestedPagelist?.search == "" || TablePositionPersist?.BlocklistRequestedPagelist?.search ==undefined? "":TablePositionPersist.BlocklistRequestedPagelist.search}
              search_key={true}

          />
        </div>
      </div>

      {EmployeePop && EmployeeIDsblacklist != undefined ? (
        <BlacklistApprove
          show={EmployeeIDsblacklist}
          setShow={setEmployeePopblack}
          currentPage={dtpageindex}
          data={data}
          EditId={EmployeeIDsblacklist}
          selectVal={selectVal}
          from_dates={range[0]}
          to_dates={range[1]}
          white_collar={filterForWhite.white_collar}
          search={search}
        />
      ) : null}

      {createblack ? (
        <BlackListCeatePoup
       show={createblack}
          setShow={setcreatepoupblack}
          currentPage={dtpageindex}
          EditId={EmployeeIDsblacklist}
          selectVal={selectVal}
          datas={data}
          from_dates={range[0]}
          to_dates={range[1]}
          white_collar={filterForWhite.white_collar}
        />
      ) : null}
    </>
  );
};

export default BlackList;
